import { connect } from 'react-redux';

import Selector from './Selector';

const mapStateToProps = state => ({
  selectedIndex: state.loadingManagement.filters.selectedIndex,
});

export default connect(mapStateToProps)(Selector);
